/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forms_Custom_Pages_Create_IconInputs */

const en_forms_custom_pages_create_icon = /** @type {(inputs: Forms_Custom_Pages_Create_IconInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Icon`)
};

const de_forms_custom_pages_create_icon = /** @type {(inputs: Forms_Custom_Pages_Create_IconInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Icon`)
};

/**
* | output |
* | --- |
* | "Icon" |
*
* @param {Forms_Custom_Pages_Create_IconInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const forms_custom_pages_create_icon = /** @type {((inputs?: Forms_Custom_Pages_Create_IconInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forms_Custom_Pages_Create_IconInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forms_custom_pages_create_icon(inputs)
	return de_forms_custom_pages_create_icon(inputs)
});